import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { BodyTextL, cs, HeadingL } from "@repo/ui";
import ChromeIcon from "@repo/ui/assets/images/chrome.svg";
import EdgeIcon from "@repo/ui/assets/images/edge.svg";
import FirefoxIcon from "@repo/ui/assets/images/firefox.svg";
import SafariIcon from "@repo/ui/assets/images/safari.svg";
import unsupportedBrowser from "@repo/ui/assets/images/unsupported-browser.png";
import { type FC } from "react";
import { LoggedOutBar } from "../../components/AppBar/Bars";
import { Seo } from "../../components/SEO";

type BrowserProps = {
    link?: string;
    icon: string;
    name: string;
};

const Browser: FC<BrowserProps> = ({ link, icon, name }) => {
    if (link) {
        return (
            <Link href={link} target="_blank" sx={{ mx: 4 }}>
                <Stack sx={{ alignItems: "center" }}>
                    <img src={icon} width="42" height="42" alt={name} />
                    <Box sx={{ mt: 2 }}>{name}</Box>
                </Stack>
            </Link>
        );
    }

    return (
        <Stack sx={{ alignItems: "center", mx: 4 }}>
            <img src={icon} width="42" height="42" alt={name} />
            <Box sx={{ mt: 2 }}>{name}</Box>
        </Stack>
    );
};

export const AppBar: FC = () => <LoggedOutBar />;

const UnsupportedBrowser: FC = () => {
    return (
        <Stack
            sx={{
                alignItems: "center",
                maxWidth: { md: "630px", xs: "100%" },
                mx: 4,
                margin: "auto",
                textAlign: "center",
            }}
        >
            <img src={unsupportedBrowser} alt="Nepodporovaný browser" />
            <HeadingL sx={{ mt: 6 }}>{cs.unsupportedBrowser.heading}</HeadingL>
            <BodyTextL>{cs.unsupportedBrowser.text}</BodyTextL>
            <Stack sx={{ mt: 6 }} direction="row">
                <Browser name="Chrome" icon={ChromeIcon} link="https://www.google.com/intl/cs_CZ/chrome/" />
                <Browser name="Firefox" icon={FirefoxIcon} link="https://www.mozilla.org/cs/firefox/new/" />
                <Browser name="Safari" icon={SafariIcon} />
                <Browser name="Edge" icon={EdgeIcon} link="https://www.microsoft.com/cs-cz/edge" />
            </Stack>
        </Stack>
    );
};

export default UnsupportedBrowser;

export const Head: FC = () => (
    <Seo title="Nepodporovaný prohlížeč">
        <meta name="robots" content="noindex" />
    </Seo>
);
